// The tax invoice document attached to a payout invoice. The publisher portal
// uploads it; the ops and brand screens only ever read it back, so everything
// about *reading* a stored document lives here rather than in either portal.

export const INVOICE_PREVIEW_KIND = {
    IMAGE: "image",
    PDF  : "pdf",
    NONE : "none"
};

// Scanned invoices arrive as photos as often as PDFs, so images are a
// first-class preview here (unlike contracts, which are only ever documents).
export const INVOICE_IMAGE_EXTENSIONS = [".png", ".jpg", ".jpeg", ".webp", ".gif"];

export const INVOICE_DOCUMENT_LABEL = {
    TITLE  : "Tax invoice",
    OPEN   : "Open document",
    MISSING: "No tax invoice has been attached to this invoice yet.",
    FAILED : "This document could not be displayed here. Open it in a new tab to read it."
};
